<template>
  <div>
    <el-menu :default-active="activeMenu"
             :collapse="collapse"
             background-color="#424f63"
             text-color="#FFFFFF"
             active-text-color="#409EFF"
             :router="true"
             :unique-opened="true"
             @select="onMenuSelect">
      <el-submenu index="/users"
                  v-permission="[5,26,118,215,262,263,264,267,269,20001,20002,20003,20004,20006]">
        <template #title>
          <i class="sj-icon-user-manager"></i>
          <span class="menu-text">用户管理</span>
        </template>
        <el-menu-item index="/users/table"
                      v-permission="5">用户列表
        </el-menu-item>
        <el-menu-item index="/users/communicate-table"
                      v-permission="264">用户沟通记录
        </el-menu-item>
        <el-menu-item index="/users/user-account-table">用户账户查询
        </el-menu-item>
        <el-menu-item index="/users/points-table">零豆管理
        </el-menu-item>
        <el-menu-item index="/users/occupation"
                      v-permission="262">自选职业
        </el-menu-item>
        <el-menu-item index="/user-workinfo/table"
                      v-permission="263">用户职业信息审核
        </el-menu-item>
        <el-menu-item index="/users/mas"
                      v-permission="26">群发消息
        </el-menu-item>
        <el-menu-item index="/usertag/table"
                      v-permission="118">标签管理
        </el-menu-item>
        <el-menu-item index="/user-cover/table"
                      v-permission="5">覆盖查询
        </el-menu-item>
        <el-menu-item index="/users/batch/table"
                      v-permission="215">批量用户
        </el-menu-item>
        <el-menu-item index="/executive-budget/approve/table"
                      >执行审批
        </el-menu-item>
        <el-menu-item index="/user-order-stat/table"
                      v-permission="267">条件搜索添加标签
        </el-menu-item>
        <el-menu-item index="/users/deleted-table"
                      v-permission="269">注销用户列表
        </el-menu-item>
        <el-menu-item index="/users/newbie-config"
                      v-permission="20001">新用户定义配置
        </el-menu-item>
        <el-menu-item index="/users/newbie-mission-config"
                      v-permission="20002">新手任务配置
        </el-menu-item>
        <el-menu-item index="/users/devices"
                      v-permission="20003"> 用户设备列表
        </el-menu-item>
        <el-menu-item index="/users/riskusers"
                      v-permission="20004"> 风险用户统计
        </el-menu-item>
        <el-menu-item index="/violation-alert/table"
                      v-permission="20006">违规预警
        </el-menu-item>
      </el-submenu>

      <el-submenu index="/stores"
                  v-permission="23">
        <template slot="title">
          <i class="sj-icon-market"></i>
          <span class="menu-text">门店管理</span>
        </template>
        <el-menu-item index="/market/table" v-permission="15">门店列表</el-menu-item>
        <el-menu-item index="/store-collection/table"
                      v-permission="15">门店信息收集
        </el-menu-item>
        <el-menu-item index="/market-ng/table"
                      v-permission="15">异常门店
        </el-menu-item>
        <el-menu-item index="/market/upload/table"
                      v-permission="48">门店上传
        </el-menu-item>
        <el-menu-item index="/city-map/table">区域管理
        </el-menu-item>
        <el-menu-item index="/map-comment-feedback/table"
                      v-permission="48">地图评价反馈
        </el-menu-item>
        <el-menu-item index="/market/cs-location-log"
                      v-permission="10001">客服修改经纬度日志
        </el-menu-item>
        <el-menu-item index="/cover-estimate/table">覆盖预估
        </el-menu-item>
      </el-submenu>

      <el-submenu index="/work-info"
                  v-permission="[283,284,285,286]">
        <template slot="title">
          <i class="el-icon-suitcase"></i>
          <span class="menu-text">职业信息管理</span>
        </template>
        <el-menu-item index="/work-info-company/table"
                      v-permission="283">职业信息公司
        </el-menu-item>
        <el-menu-item index="/work-info-business-type/table"
                      v-permission="284">职业信息行业
        </el-menu-item>
        <el-menu-item index="/work-info-work-type/table"
                      v-permission="285">职业信息工种
        </el-menu-item>
        <el-menu-item index="/work-info-business-type/batch-jobs"
                      v-permission="286">批量任务
        </el-menu-item>
      </el-submenu>

      <el-submenu index="/task"
                  v-if="canViewTaskMenu">
        <template slot="title">
          <i class="sj-icon-task-manager"></i>
          <span class="menu-text">任务管理</span>
        </template>
        <el-menu-item index="/task/table">任务管理</el-menu-item>
        <el-menu-item index="/task/archived/table">任务管理(归档)</el-menu-item>
        <el-menu-item index="/order/table">工单管理</el-menu-item>
        <el-menu-item index="/order/archived/table">工单管理(归档)</el-menu-item>
        <el-menu-item index="/task-order/table">任务工单管理</el-menu-item>
        <el-menu-item index="/order/appeal/table" v-permission="289">工单申诉管理</el-menu-item>
        <!--<el-menu-item index="/task-order/table">任务&工单管理</el-menu-item>-->
        <el-menu-item v-permission="90" index="/step-template/table">分步模板</el-menu-item>
        <el-menu-item index="/price-batch"
                      v-permission="83">调价批次
        </el-menu-item>
        <el-menu-item index="/task/batch/table" v-permission="238">批量任务</el-menu-item>
        <el-menu-item index="/middle-end-task/audit/table" v-permission="239">任务审批</el-menu-item>
        <el-menu-item index="/task-notice" v-permission="237">任务提示</el-menu-item>
        <el-menu-item index="/group-batch/customer-table" v-permission="245">群组控制</el-menu-item>
        <el-menu-item index="/midan/table" v-permission="249">米单配置</el-menu-item>

        <el-menu-item v-permission="282" index="/task/map">任务地图看板</el-menu-item>
      </el-submenu>

      <el-submenu index="/banquet-task"
                  v-permission="36001">
        <template slot="title">
          <i class="el-icon-s-order"></i>
          <span class="menu-text">新宴席管理</span>
        </template>
        <el-menu-item index="/banquet-task/records" v-permission="36001">宴席任务</el-menu-item>
        <el-menu-item index="/banquet-task/batch" v-permission="36001">宴席批量导入</el-menu-item>
      </el-submenu>

      <el-submenu index="/platform" v-permission="[30,224,261,266,13001]">
        <template slot="title">
          <i class="el-icon-s-platform"></i>
          <span class="menu-text">平台管理</span>
        </template>
        <el-menu-item index="/app-banner/table"
                      v-permission="29">App Banner管理
        </el-menu-item>
        <el-menu-item index="/app-popup/table" v-permission="253">
          App浮窗管理
        </el-menu-item>
        <el-menu-item index="/platform-user"
                      v-permission="0">平台用户管理
        </el-menu-item>
        <el-menu-item index="/settings/set-project-config"
                      v-permission="-100">项目审核人管理
        </el-menu-item>
        <el-menu-item index="/settings/set-receipt-apply-config"
                      v-permission="-100">开票抄送人管理
        </el-menu-item>
        <el-menu-item index="/permission-apply/table">权限申请
        </el-menu-item>
        <el-menu-item index="/platform/tag_table"
                      v-permission="29">热标签搜索
        </el-menu-item>
        <el-menu-item index="/platform/education_table"
                      v-permission="29">教程管理
        </el-menu-item>
        <el-menu-item index="/flbanner/table"
                      v-permission="230">福利社管理
        </el-menu-item>
        <el-menu-item index="/platform/home-module-table"
                      v-permission="29">APP首页模块管理
        </el-menu-item>
        <el-menu-item index="/platform/sign-feedback-table">签到问题反馈
        </el-menu-item>
        <el-menu-item index="/platform/order-comment-table">评价管理
        </el-menu-item>
        <el-menu-item index="/platform-upload/table"
                      v-permission="0">平台上传管理
        </el-menu-item>
        <el-menu-item index="/task-package-home"
                      v-permission="29">首页任务包设置
        </el-menu-item>
        <el-menu-item index="/project-task-package"
                      v-permission="13001">任务包及培训配置
        </el-menu-item>
        <el-menu-item index="/platform-user-whitelist">发布白名单用户
        </el-menu-item>
        <el-menu-item index="/platform-androidapk-test">安卓APK发布
        </el-menu-item>
        <el-menu-item index="/batch-jobs/all-batch-jobs-table"
                      v-permission="252">
          所有批量任务列表
        </el-menu-item>
        <!-- 原「活动管理」并入 -->
        <el-menu-item index="/fair/table"
                      v-permission="224">活动管理
        </el-menu-item>
        <el-menu-item index="/launch-page-activity/table">启动页活动
        </el-menu-item>
        <el-menu-item index="/fair-upload/table"
                      v-permission="224">活动上传管理
        </el-menu-item>
        <!-- 原「智能外呼」并入 -->
        <el-menu-item index="/intelligent-outbound-call/table"
                      v-permission="261">智能外呼
        </el-menu-item>
        <el-menu-item index="/intelligent-outbound-call/upload"
                      v-permission="261">外呼批量任务
        </el-menu-item>
        <!-- 原「智能客服管理-参数配置」并入 -->
        <el-menu-item index="/intelligent-customer-service/update"
                      v-permission="266">智能客服参数配置
        </el-menu-item>
      </el-submenu>

      <el-submenu index="/finance"
                  v-permission="[18]">
        <template slot="title">
          <i class="sj-icon-finance-manager"></i>
          <span class="menu-text">财务管理</span>
        </template>
        <el-menu-item index="/finance/batch-withdraw-table"
                      v-permission="18">批量提现列表
        </el-menu-item>
        <el-menu-item index="/finance/withdraw-bank-table"
                      v-permission="18">银行卡提现管理
        </el-menu-item>
        <el-menu-item index="/finance/bank-withdraw-table"
                      v-permission="18">银行卡提现批次管理
        </el-menu-item>
        <el-menu-item index="/finance/withdraw-alipay-table"
                      v-permission="18">支付宝提现管理
        </el-menu-item>
        <el-menu-item index="/finance/alipay-withdraw-table"
                      v-permission="18">支付宝提现批次管理
        </el-menu-item>
        <el-menu-item index="/finance/withdraw-wx-table"
                      v-permission="18">微信提现管理
        </el-menu-item>
        <el-menu-item index="/finance/wx-withdraw-table"
                      v-permission="18">微信提现批次管理
        </el-menu-item>
        <el-menu-item index="/finance/batch-withdraw-option-table"
                      v-permission="18">批量提现操作列表
        </el-menu-item>
        <el-menu-item index="/finance/inactive-user-table">不活跃用户
        </el-menu-item>
        <el-menu-item index="/invoice-apply/approve/table">开票审批
        </el-menu-item>
        <el-menu-item index="/finance/ajx/project/table"
                      v-permission="18">爱绩效项目审核
        </el-menu-item>
        <el-menu-item index="/received-approval">回款管理
        </el-menu-item>
        <el-menu-item index="/invoice-apply/received-payment/table/type/1">回款管理(旧)
        </el-menu-item>
        <el-menu-item v-permission="234" index="/payment-approval/table">付款审批
        </el-menu-item>
        <el-menu-item v-permission="291" index="/payment-approval-new/table">付款审批(新)</el-menu-item>
        <el-menu-item v-permission="292" index="/payment-center/table">支付中心(新)</el-menu-item>
        <el-menu-item v-permission="234" index="/payment-refund/finance/table">付款退款</el-menu-item>
        <el-menu-item index="/batch-jobs/finance-export-jobs">财务数据导出任务</el-menu-item>
      </el-submenu>

      <el-submenu index="/finance-config"
                  v-permission="[271, 272, 273, 274, 275, 276, 277, 278, 279, 280, 281, 27001]">
        <template slot="title">
          <i class="sj-icon-caidanlan-caiwu-caiwushezhi"></i>
          <span class="menu-text">财务中心设置</span>
        </template>
        <el-menu-item index="/finance-config/approval-value"
                      v-permission="271">审批起始值
        </el-menu-item>
        <el-menu-item index="/finance-config/subject-management"
                      v-permission="272">付款科目管理
        </el-menu-item>
        <el-menu-item index="/finance-config/company-account"
                      v-permission="273">公司管理
        </el-menu-item>
        <el-menu-item index="/finance-config/company-account-management/table"
                      v-permission="277">账户管理
        </el-menu-item>
        <el-menu-item index="/finance-config/invoice-name-management"
                      v-permission="278">开票名称管理
        </el-menu-item>
        <el-menu-item index="/finance-config/department-management"
                      v-permission="274">部门管理
        </el-menu-item>
        <el-menu-item index="/company-bank-account/table"
                      v-permission="275">对公账户列表
        </el-menu-item>
        <el-menu-item index="/user-bank-account/table"
                      v-permission="276">员工账户列表
        </el-menu-item>
        <el-menu-item index="/customer-receipt/table"
                      v-permission="279">客户开票信息管理
        </el-menu-item>
        <el-menu-item index="/pay-conditions/table"
                      v-permission="280">账期管理
        </el-menu-item>
        <el-menu-item index="/finance-config/finance-email-notify"
                      v-permission="27001">财务邮件设置
        </el-menu-item>
        <el-menu-item index="/finance-config/tax-panel"
                      v-permission="281">百旺自动开票配置管理
        </el-menu-item>
      </el-submenu>
      <!-- <el-submenu index="/teke"
                  v-permission="231">
        <template slot="title">
          <i class="sj-icon-questionnaire"></i>
          <span class="menu-text">TE-KE管理</span>
        </template>
        <el-menu-item index="/teke-order/table">全部问卷</el-menu-item>
        <el-menu-item index="/teke-order/audit-table">待复审问卷</el-menu-item>
        <el-menu-item index="/teke_customer/table">客户管理</el-menu-item>
        <el-menu-item index="/teke_tag/table">标签管理</el-menu-item>
      </el-submenu> -->

      <!-- 查理宝平台：侧栏隐藏（菜单整理方案），下方子菜单原样保留在注释中；路由仍注册，可直接输入 URL 访问 -->
      <!--
      <el-submenu index="/clb" v-permission="140">
        <template slot="title">
          <i class="sj-icon-chalibao"></i>
          <span class="menu-text">查理宝平台</span>
        </template>
        <el-menu-item index="/order/table/platform/1/status/40">
          待复审工单
        </el-menu-item>
        <el-menu-item index="/order/table/platform/1">
          工单列表
        </el-menu-item>
        <el-menu-item index="/step-template/table/type/20">
          分步模板
        </el-menu-item>
        <el-menu-item index="/clb-task-template/table">
          任务模板
        </el-menu-item>
        <el-menu-item index="/customer/table/type/20"
                      v-permission="62">
          客户管理
        </el-menu-item>
        <el-menu-item index="/customer-task/table/type/20"
                      v-permission="207">客户任务管理
        </el-menu-item>
        <el-menu-item index="/customer-projectcost/table/type/ee"
                      v-permission="145">
          项目成本列表
        </el-menu-item>
        <el-menu-item index="/clb-product-area/table">
          任务区域分类管理
        </el-menu-item>
        <el-menu-item index="/clb-alipay-flow/table">
          支付宝流水
        </el-menu-item>
      </el-submenu>
      -->

      <el-submenu index="/customer"
                  v-permission="[62,193,207,240,241,242,243,244,248,14001]">
        <template slot="title">
          <i class="sj-icon-customer"></i>
          <span class="menu-text">客户管理</span>
        </template>
        <el-menu-item index="/customer/table"
                      v-permission="62">客户管理
        </el-menu-item>
        <el-menu-item index="/customer/ajx/table"
                      v-permission="62">爱绩效客户管理
        </el-menu-item>
        <el-menu-item index="/customer-task/table"
                      v-permission="207">客户任务管理
        </el-menu-item>
        <el-menu-item index="/project/progress-table"
                      v-permission="14001">项目进度列表
        </el-menu-item>
        <el-menu-item index="/customer-projectcost/table"
                      v-permission="193">项目成本列表
        </el-menu-item>
        <el-menu-item index="/satisfaction-email/table"
                      v-permission="62">满意度邮件
        </el-menu-item>
        <el-menu-item v-permission="240" index="/invoice-apply/table">开票管理
        </el-menu-item>
        <el-menu-item v-permission="241" index="/received-payment">回款管理
        </el-menu-item>
        <el-menu-item v-permission="242" index="/invoice-apply/received-payment/table/type/10">回款管理(旧)
        </el-menu-item>
        <el-menu-item v-permission="248" index="/customer/batch-table">批量客户
        </el-menu-item>
        <el-menu-item index="/executive-budget/table"
        >
          执行预算分配
        </el-menu-item>
        <el-menu-item v-permission="243" index="/payment-manager/table">付款管理
        </el-menu-item>
        <el-menu-item v-permission="244" index="/payment-refund/table">付款退款</el-menu-item>
        <el-menu-item v-permission="246" index="/payment-manager-new/table">付款管理(新)
        </el-menu-item>
      </el-submenu>

      <el-submenu index="/todo"
                  v-permission="[2081]">
        <template slot="title">
          <i class="el-icon-tickets"></i>
          <span class="menu-text">待办事项</span>
        </template>
        <el-menu-item index="/todo/project/table">项目审核
        </el-menu-item>
      </el-submenu>

      <!-- 统计管理：原 v-permission="[25]"；并入「推广项目进度」后父级用 canViewStatisticMenu，使无 25 的非实习生仍能进组（与原先独立一级 /big-data 一致） -->
      <el-submenu index="/statistic" v-if="canViewStatisticMenu">
        <template slot="title">
          <i class="sj-icon-statistic"></i>
          <span class="menu-text">统计管理</span>
        </template>
        <el-menu-item v-permission="25" index="/statistic/city-group-config">城市分组配置</el-menu-item>
        <el-menu-item v-permission="25" index="/statistic/promoter">推广人员配置</el-menu-item>
        <el-menu-item v-permission="25" index="/statistic/screen-project">大屏项目配置</el-menu-item>
        <el-menu-item v-permission="25" index="/statistic/screen-project/audit-screen-config">审单大屏配置</el-menu-item>
        <el-menu-item v-permission="25" index="/statistic/screen-project/batch-jobs">批量任务</el-menu-item>
        <!-- 原独立一级「推广项目进度」并入统计管理（仍仅非实习生可见） -->
        <el-menu-item index="/big-data"
                      v-if="!isIntern">推广项目进度
        </el-menu-item>
      </el-submenu>

      <el-submenu index="/audit-intern"
                  v-permission="[40001,40008,40009,40013]">
        <template slot="title">
          <i class="sj-icon-user-manager"></i>
          <span class="menu-text">实习生管理</span>
        </template>
        <el-menu-item v-permission="40001" index="/audit-intern/table">实习生列表</el-menu-item>
        <el-menu-item v-permission="40008" index="/audit-intern/cronjob">实习生批量任务</el-menu-item>
        <el-menu-item v-permission="40009" index="/audit-intern/monthly-onduty-table">实习生月度出勤</el-menu-item>
        <el-menu-item v-permission="40014" index="/audit-intern/attendance-plan-monthly">考勤计划月度列表</el-menu-item>
        <el-menu-item v-permission="40013" index="/audit-intern/performance">审单绩效统计</el-menu-item>
      </el-submenu>

      <el-submenu index="/workbench" title="工作管理" v-if="isIntern">
        <template slot="title">
          <i class="el-icon-s-home"></i>
          <span class="menu-text">工作管理</span>
        </template>
        <el-menu-item index="/workbench">工作台</el-menu-item>
        <el-menu-item index="/customer/customer-order-review/table">客户审单管理</el-menu-item>
        <el-menu-item index="/audit-task/table">我的审单</el-menu-item>
        <el-menu-item index="/training/self-examination">我的问卷</el-menu-item>
        <el-menu-item index="/workbench/attendance-plan">出勤设置</el-menu-item>
        <el-menu-item index="/admin-inbox-message/table">
          <span class="inbox-menu-label">
            消息通知
            <el-badge v-if="unreadInboxCount > 0"
                      :value="unreadInboxCount"
                      :max="99"
                      class="inbox-menu-badge">
            </el-badge>
          </span>
        </el-menu-item>
      </el-submenu>

      <el-submenu index="/audit-task-setting" title="审单管理" v-permission="[85,86,87,88]">
        <template slot="title">
          <i class="sj-icon-task-manager"></i>
          <span class="menu-text">审单管理</span>
        </template>
        <!-- 第二期的内容 <el-menu-item index="/audit-task-setting/project-order-review/table">项目审单统计</el-menu-item> -->
        <el-menu-item v-permission="85" index="/audit-task-setting/table">审单系统配置</el-menu-item>
        <el-menu-item v-permission="86" index="/order/assigned-review-table">待分配复核列表</el-menu-item>
        <el-menu-item v-permission="87" :index="`/task/review-task-table?adminid=${user.id}`">复核任务列表</el-menu-item>
        <el-menu-item v-permission="88" index="/task/review-plan/table">复核目标配置</el-menu-item>
        <el-menu-item v-permission="87" index="/audit-task-setting/return-order-evaluation/table">退单评价列表</el-menu-item>
      </el-submenu>

      <el-submenu index="/order-review-assessment" v-permission="[41,42,43]" title="审单考核管理">
        <template slot="title">
          <i class="el-icon-tickets"></i>
          <span class="menu-text">审单考核管理</span>
        </template>
        <!-- 第三期的内容 <el-menu-item index="/order-review-assessment/questionnaire-config" v-permission="41">问卷配置
        </el-menu-item> -->
        <el-menu-item index="/audit-intern/attendance-project-target/table" v-permission="43">项目出勤配置
        </el-menu-item>
        <el-menu-item index="/order-review-assessment/target-setting" v-permission="41">审单目标配置
        </el-menu-item>
        <el-menu-item index="/order-review-assessment/keyin-exception-feedback" v-permission="42">KeyIn异常工单反馈
        </el-menu-item>
      </el-submenu>

      <!-- <el-submenu index="/recruit"
                  v-permission="227">
        <template slot="title">
          <i class="sj-icon-recruit-employ"></i>
          <span class="menu-text">招聘管理</span>
        </template>
        <el-menu-item index="/position/table">职位列表</el-menu-item>
        <el-menu-item index="/position/pending-audit-table">待审核职位</el-menu-item>
        <el-menu-item index="/position/audit-table">已审核职位</el-menu-item>
        <el-menu-item index="/position/upload">批量上传</el-menu-item>
        <el-menu-item index="/resume/all_table">全部简历</el-menu-item>
      </el-submenu> -->

      <!-- 流转识别：侧栏隐藏（菜单整理方案），下方子菜单原样保留在注释中；路由仍注册，可直接输入 URL 访问 -->
      <!--
      <el-submenu index="/img-flow-config" v-permission="30">
        <template slot="title">
          <i class="sj-icon-flow"></i>
          <span class="menu-text">流转识别</span>
        </template>
        <el-menu-item index="/img-flow-config/table">
          流转配置管理
        </el-menu-item>
        <el-menu-item index="/img-flow-order/table">
          流转工单管理
        </el-menu-item>
        <el-menu-item index="/img-flow-product/table">
          识别产品管理
        </el-menu-item>
      </el-submenu>
      -->

      <!-- 人事管理 -->
      <el-submenu index="/hr" v-permission="290">
        <template slot="title">
          <i class="sj-icon-activity"></i>
          <span class="menu-text">人事管理</span>
        </template>
        <el-menu-item index="/hr/employee" v-permission="290">员工管理</el-menu-item>
      </el-submenu>
      <!-- 考试培训管理 -->
      <el-submenu index="/training" v-permission="[34001,34002,34003,34004,34005]">
        <template slot="title">
          <i class="el-icon-notebook-2"></i>
          <span class="menu-text">考试培训管理</span>
        </template>
        <el-menu-item index="/training/instruction" v-permission="34001">培训管理</el-menu-item>
        <el-menu-item index="/training/user-course" v-permission="34002">零工教程管理</el-menu-item>
        <el-menu-item index="/training/intern-course" v-permission="34006">实习生教程管理</el-menu-item>
        <el-menu-item index="/training/examination" v-permission="34003">零工考试管理</el-menu-item>
        <el-menu-item index="/training/intern-examination" v-permission="34007">实习生考试管理</el-menu-item>
        <el-menu-item index="/training/question" v-permission="34004">题目管理</el-menu-item>
        <el-menu-item index="/training/knowledge" v-permission="34005">知识库管理</el-menu-item>
      </el-submenu>
      <!-- 录音风险管理 -->
      <el-submenu index="/audio-asr-check" v-permission="[35001,35002,35003]">
        <template slot="title">
          <i class="el-icon-microphone"></i>
          <span class="menu-text">录音风险管理</span>
        </template>
        <el-menu-item index="/audio-asr-check/template" v-permission="35002">录音风险配置</el-menu-item>
        <el-menu-item index="/audio-asr-check/result" v-permission="35003">录音风险列表</el-menu-item>
        <el-menu-item index="/audio-asr-check/stats" v-permission="35001">项目统计</el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
import {getUnreadInboxMessageCount} from '@views/admin-inbox-message/admin-inbox-message.api'

export default {
  components: {},
  data () {
    return {
      unreadInboxCount: 0,
      unreadInboxTimer: null,
    }
  },
  computed: {
    ...Vuex.mapState({
      collapse: state => state.collapseMenu,
      autoCollapseMenu: state => state.autoCollapseMenu,
      user: state => state.login.user,
    }),
    isIntern () {
      return parseInt(this.user.usertype) === 4
    },
    canViewTaskMenu () {
      // 非实习生保持现状；实习生额外要求具备新的 UI 权限
      return !this.isIntern || filter.hasPermission(40010)
    },
    /** 统计管理：具备 UI 权限 25，或非实习生（可展示并入的「推广项目进度」，与原先仅 !isIntern 可见一致） */
    canViewStatisticMenu () {
      return filter.hasPermission(25) || !this.isIntern
    },
    activeMenu () {
      const matched = this.$route.matched
      for (let i = matched.length - 1; i >= 0; i--) {
        const menu = matched[i].meta && matched[i].meta.activeMenu
        if (menu) {
          return menu
        }
      }
      return this.$route.path
    },
  },
  watch: {},
  created () {
    if (!this.isIntern) return

    this.loadUnreadInboxCount()
    this.unreadInboxTimer = window.setInterval(() => {
      this.loadUnreadInboxCount()
    }, 10 * 60 * 1000)
  },
  beforeDestroy () {
    if (this.unreadInboxTimer !== null) {
      window.clearInterval(this.unreadInboxTimer)
      this.unreadInboxTimer = null
    }
  },
  methods: {
    ...Vuex.mapMutations([
      'COLLAPSE_MENU',
    ]),
    onMenuSelect (index, indexPath) {
      // console.log(index, indexPath)
      if (this.autoCollapseMenu) {
        this.COLLAPSE_MENU(true)
      }
    },
    loadUnreadInboxCount () {
      return getUnreadInboxMessageCount().then(response => {
        const body = response && response.data
        if (!body || body.ret !== 0 || typeof body.detail !== 'number' || !isFinite(body.detail) || body.detail < 0) return

        this.unreadInboxCount = body.detail
      }).catch(() => {})
    }
  },
}
</script>

<style lang="scss">

</style>

<style lang="scss"
       scoped>
.el-menu {
  border-right: solid 0px #e6e6e6;

  &:not(.el-menu--collapse) {
    padding-bottom: 56px;
  }
}

.el-submenu i,
.el-menu-item i {
  color: #bfcbd9;
}

.el-submenu__title i,
.el-menu-item i {
  color: #FFFFFF;

  &[class^=sj-icon-] {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    font-size: 18px;
    margin-right: 5px;
    margin-left: 0;
    vertical-align: middle;
  }
}
.el-icon-arrow-down {
  color: #FFFFFF;
}

.el-submenu__icon-arrow {
  color: #FFFFFF;
}
.menu-text {
  padding-left: 10px;
}

.inbox-menu-label {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-right: 12px;
  box-sizing: border-box;
}

.inbox-menu-badge {
  line-height: 1;
}
</style>



// WEBPACK FOOTER //
// src/layout/LayoutMenu.vue